import {Column, Entity, OneToOne} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {Team} from "@/modules/team/entity";
import {Min} from "class-validator";
import {SponsorTypeEnum} from "@/modules/sponsoring/enums";

@Entity({orderBy: {id: 'DESC'}})
export class Sponsor extends BaseEntity {
  @Column({type: "varchar", enum: SponsorTypeEnum})
  type: SponsorTypeEnum;

  @Column({type: "boolean"})
  accepted = false;

  @Column({type: "varchar"})
  name: string;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  once: number;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  perLeagueMatch: number;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  perLeagueVictory: number;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  perCupMatch: number;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  perCupVictory: number;
}
